import { render, staticRenderFns } from "./RecycleView.vue?vue&type=template&id=19000b42&scoped=true"
import script from "./RecycleView.vue?vue&type=script&lang=js"
export * from "./RecycleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19000b42",
  null
  
)

export default component.exports